import actionsPermissionsActions from "../actions/actionsPermissionsActions";
import { actionsPermissionsService } from "../../services/actionsPermissionsService";

import { OperationsFactory } from "./ProtectedOperationsFactory";

const fetch = OperationsFactory.createFetchMethod(
  actionsPermissionsActions,
  actionsPermissionsService.fetch
);

const setFiltered = actionsPermissionsActions.fetchSuccess;

const fetchAll = OperationsFactory.createFetchAllMethod(
  actionsPermissionsActions,
  actionsPermissionsService.fetchAll
);

const update = OperationsFactory.createUpdateOrCreateAllMethod(
  actionsPermissionsActions,
  actionsPermissionsService.update
);

export const actionsPermissionsOperations = {
  fetch,
  fetchAll,
  update,
  setFiltered,
};
